import type { FC } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { Text } from "@/components/podkit/typography/Text";
import Breadcrumbs from "@/components/Breadcrumb";
import { workflowsUrl } from "@/utils/automations";
import { useDocumentTitle } from "@/hooks/use-document-title";
import { WebhookList } from "@/components/webhooks/WebhookList";
import { useFlagReusableWebhooksEnabled } from "@/hooks/use-flag";
import { LoadingState } from "@/components/podkit/loading/LoadingState";

export const WebhooksPage: FC = () => {
    useDocumentTitle("Webhooks");
    const { value: isReusableWebhooksEnabled, loading: isLoadingFlag } = useFlagReusableWebhooksEnabled();

    if (isLoadingFlag) {
        return <LoadingState />;
    }

    if (!isReusableWebhooksEnabled) {
        return <Navigate to={workflowsUrl()} replace />;
    }

    return (
        <div data-testid="webhooks-page" className="flex h-full grow flex-col gap-6">
            <div className="flex items-start justify-between">
                <div className="flex flex-col gap-1">
                    <Breadcrumbs
                        customBreadcrumbs={[{ label: "Automations", to: workflowsUrl() }, { label: "Webhooks" }]}
                    />
                    <Text className="text-content-base text-base">Manage webhooks for your automations.</Text>
                </div>
            </div>
            <WebhookList />
            <Outlet />
        </div>
    );
};
